module.exports = __webpack_public_path__ + "static/img/a073.93b55dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a073.jpg
// module id = gPmS
// module chunks = 0